<template lang="html">
  <div class="choose-city">
    <!-- <div v-if="locating"  class="city-location">
            <p>定位中...</p>
        </div>
        <div v-else class="city-location" @click="clickLocate(locateCity)">
            <p v-if="locateCity.ID">定位城市：</p>
            <p v-if="locateCity.ID">{{locateCity.NAME}}</p>
            <p v-else>定位失败</p>
        </div> -->
    <!-- <div class="city-hot">
            <p>热门城市</p>
            <ul>
                <li>1111</li>
            </ul>
        </div> -->
    <!-- <div class="city-history" v-show="historyCity.length > 0">
            <p>历史访问城市</p>
            <ul>
                <li v-for="city in historyCity" :key="city.ID" @click="clickCity(city, 'history')">{{city.NAME}}</li>
            </ul>
        </div> -->
    <div class="city-all">
      <dl v-for="(item, index) in allCity" :key="index">
        <dt :data-label="getKey(item)">{{ getKey(item) }}</dt>
        <dd>
          <ul>
            <li
              v-for="city in getValue(item)"
              :key="city.ID"
              @click="clickCity(city)"
            >
              {{ city.NAME }}
            </li>
          </ul>
        </dd>
      </dl>
    </div>
    <letter :letterList="letters" :wrapper="wrapper"></letter>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import fetch from '@/plugins/fetch'
import storage from '@/plugins/localStorage'
import letter from './letter'

export default {
  props: {
    wrapper: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      hotCity: [],
      historyCity: [],
      allCity: []
      // locating: false
    }
  },
  created() {
    this.getCity()
    // this.getHistotyCity()
    // this.$$loading(false)
    // this.$$title('选择城市')
  },
  computed: {
    ...mapState(['locateCity', 'locating', 'choosedCity']),
    letters() {
      return this.allCity.map(ele => this.getKey(ele))
    }
  },
  methods: {
    ...mapMutations(['setChoosedCity']),
    async getCity() {
      try {
        const allCity_res = await fetch(
          `${this.hostname('address')}/addressview/GetAllCityList`
        )
        const allCityJson = await allCity_res.json()
        if (allCityJson) {
          const d = allCityJson.data
          // 按拼音首字母A-Z排序
          d.sort((a, b) => {
            const a_pinyin = this.firstWordUpper(a.PINYIN)
            const b_pinyin = this.firstWordUpper(b.PINYIN)
            if (a_pinyin > b_pinyin) {
              return 1
            } else if (a_pinyin === b_pinyin) {
              return 0
            } else {
              return -1
            }
          })

          const obj = {}
          const arr = []

          d.forEach(v => {
            const firstLetter = v.PINYIN.charAt(0).toUpperCase()
            if (obj[firstLetter]) {
              obj[firstLetter].push(v)
            } else {
              obj[firstLetter] = []
              obj[firstLetter].push(v)
            }
          })

          Object.keys(obj)
            .sort()
            .forEach(v => {
              const temp = {}
              temp[v] = obj[v]
              arr.push(temp)
            })
          this.allCity = arr
        }
      } catch (e) {
        console.log(e)
      }
    },
    getHistotyCity() {
      const cities = storage.getItem('hisCity')
      if (cities && cities.length > 0) {
        this.historyCity = cities
      }
    },
    clickCity(city, type) {
      const cities = storage.getItem('hisCity')
      if (cities && cities.length > 0) {
        let i = 0
        const checkedCity = cities.filter((ele, index) => {
          if (ele.ID === city.ID) {
            i = index
          }
          return ele.ID === city.ID
        })
        if (checkedCity && checkedCity.length > 0) {
          cities.splice(i, 1)
        } else if (cities.length >= 6) {
          cities.pop()
        }
        cities.unshift(city)
        storage.setItem('hisCity', cities)
        // this.getHistotyCity()
      } else {
        storage.setItem('hisCity', [city])
      }
      if (type === 'history') {
        this.$$tracker('130201', '20000', 2110, city.NAME)
      } else {
        this.$$tracker('130201', '20000', 21108, city.NAME)
      }
      this.$emit('selectCity', city)
      this.setChoosedCity(city)
      // location.replace(`/v/home?citycode=${city.ID}&cityname=${city.NAME}&source=citylist`)
    },
    getKey(obj) {
      return Object.keys(obj)[0]
    },
    getValue(obj) {
      return obj[Object.keys(obj)[0]]
    },
    firstWordUpper(pinyin) {
      return pinyin.match(/^[A-Z]?[a-z]*/)[0].toUpperCase()
    },
    hostname(prefix = '') {
      const hn = location.hostname
      return hn.indexOf('haiziwang.com') > -1
        ? `//${prefix}.haiziwang.com`
        : `//${prefix}.cekid.com`
    },
    clickLocate(city) {
      // this.$emit('selectCity', city)
      // if (city.isAddress || city.isLocated) {
      // }
      if (city.ID && city.ID !== '') {
        this.clickCity(city)
      }
    }
  },
  components: {
    letter
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';
.choose-city {
  background: #f4f4f4;
  font-size: rem(28px);

  .city-location {
    display: flex;
    align-items: center;
    padding: 0 rem(20px);
    height: rem(80px);
    background: #fff;

    > p:first-of-type {
      color: #999;
    }
    > p:last-of-type {
      flex: 1;
    }
  }
  .city-hot,
  .city-history {
    background: #f4f4f4;
    padding: 0 rem(20px);

    p {
      height: rem(80px);
      line-height: rem(80px);
      color: #999;
    }
    ul {
      margin-bottom: rem(-20px);
      overflow: hidden;
    }
    li {
      float: left;
      width: rem(200px);
      // height: rem(60px);
      margin: 0 rem(20px) rem(30px) 0;
      background: #fff;
      text-align: center;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      line-height: rem(60px);

      @include border(all, #999);
    }
  }
  .city-all {
    dt {
      height: rem(80px);
      padding-left: rem(20px);
      font-size: rem(32px);
      line-height: rem(80px);
      background: #f4f4f4;
      color: #999;
    }
    ul {
      padding-left: rem(20px);
      background: #fff;
    }
    li {
      height: rem(80px);
      line-height: rem(80px);
      @include border(bottom, #e8e8e8);

      &:last-child {
        &::after {
          display: none;
        }
      }
    }
  }
}
</style>
